export const HOME_PAGE = '/';
export const LOGIN_PAGE = '/login';
export const REGISTER_PAGE = '/register';
export const SUCCESSFUL_REGISTRATION_PAGE = '/successful-registration';
export const ADD_VACCINATION_PAGE = '/add-vaccination';
export const REGISTER_FINDING_PET_PAGE = '/register-finding-pet';
export const SUCCESSFUL_REPORT = '/successful-report';
